import React, { useContext, useEffect } from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Login/Login.css'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import UserContext from '@/product/context/user/userContext'
import AuthContext from '@/product/context/auth/authContext'
const ResetComponent = (props) => {
    const userContext = useContext(UserContext)
    const { resetPassword, responseStatus, clearResponse } = userContext
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const history = useHistory()
    const formik = useFormik({
        initialValues: props.initialValues,
        validationSchema: props.validationArray,
        onSubmit: (values) => {
            resetPassword(values)
        },
    })

    const resetPasswordData = {
        formik: formik,
        data: props.resetPasswordData,
    }

    useEffect(() => {
        if (isAuthenticated) {
            handleRedirectInternal(history, '')
        }
    }, [isAuthenticated])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'resetPassword') {
                if (responseStatus.status === 'success') {
                    if (props.onSuccess) {
                        props.onSuccess()
                    } else {
                        handleRedirectInternal(history, '')
                    }
                }
            }
        }
    }, [responseStatus])

    return (
        <form onSubmit={formik.handleSubmit} autoComplete="nofill">
            <div className="row">
                {Object.values(mapData(resetPasswordData))}
                <div className="col-12 d-flex justify-content-center">
                    <PrimaryButton id="passwordData_change" type="submit" label={'Change'} />
                </div>
            </div>
        </form>
    )
}
export default ResetComponent
